// extracted by mini-css-extract-plugin
export default {"container":"tL","productarea":"uL","btn":"vL","promowrapper":"wL","upsellarea":"xL","subtitle":"yL","system":"zL","desc":"AL","cardswrap":"BL","cards":"CL","squareloadingcontainer":"EL","squareloading33":"FL"};
    if(module.hot) {
      // 1737143662410
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  